import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Card from 'react-bootstrap/Card';
import AppCard from 'components/Card/Card';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import { parseStringField, checkGroupFields, checkMapping } from "helpers/FieldHelper";
import { getImgUrl } from "helpers/ImageHelper";
import { pubPath } from 'helpers/AppHelper';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as CartHelper from "helpers/CartHelper";
import './WorkItem.scss';

const WorkItem = observer(
    class WorkItem extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        onWorkItem = () => {
            const { viewMode } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentWork: this.props.work,
                viewMode: ConfigTypes.WORK_DETAIL,
                toTop: true,
                lastView: viewMode
            });

            if (this.props.work && this.props.work.id) {
                this.props.getWork({ workId: this.props.work.id });
            }

            this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${this.props.work.id}`);
        }

        showPortraitCard = (viewMode) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.work });
            const showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.WORK });
            return (
                <Card className="workitem-card">
                    <Card.Img variant="top" src={imgUrl} onClick={this.onWorkItem}
                        className="workitem-card-img" />
                    <Card.Body>
                        {showFields.map((el, i) => {

                            let isDate = el[`${viewMode}group`] && el[`${viewMode}group`].dategroup;
                            return (
                                <div key={`workitemGridItem${i}`}
                                    className={el[`${viewMode}html`] ? 'workitem-card-title' : 'workitem-card-text'}>
                                    {!isDate && parseStringField(this.props.work.metadata.fields[el.field])}
                                    {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.work, viewMode })}
                                </div>)
                        })}
                    </Card.Body>
                </Card>)
        }

        getShowFields = () => {
            const { workSearch, viewMode } = this.props.mediaObjects;
            let showFields = [];
            if (workSearch) showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.WORK });
            else showFields = getMetaConfig({ viewMode, props: this.props, configName: ConfigTypes.OBJECT });
            return showFields;
        }

        showGridItem = (viewMode) => {
            const imgUrl = getImgUrl({ stateCurrentClip: this.props.work });
            let showFields = this.getShowFields();
            return this.showPortraitCard(viewMode);
        }

        showWorkItem = () => {
            const { viewMode } = this.props.mediaObjects;
            if (viewMode == ConfigTypes.GRID) {
                return this.showGridItem(viewMode);
            } else if (viewMode == ConfigTypes.LIST) {
                let showFields = this.getShowFields();
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.work });
                return (
                    <li className="list-group-item workitem-list-item" onClick={this.onWorkItem}>
                        <img className="img-responsive img-rounded workitem-img" src={imgUrl} alt="" />
                        {showFields.map((el, i) => {
                            let fieldTxt = parseStringField(this.props.work.metadata.fields[el.field], el[`${viewMode}filterType`]);
                            fieldTxt = checkMapping({ el, fieldTxt, term: ";" });
                            return (
                                <div key={`workitemListItem${i}`}
                                    className={el[`${viewMode}html`] ? 'workitem-card-title' : 'workitem-card-text'}>
                                    {fieldTxt}
                                    {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.work, viewMode })}
                                </div>)
                        })}
                    </li>)
            }
        }

        showThumb = (imgUrl) => {
            return (
                <div className="workitem-card-imgbox" onClick={this.onWorkItem}>
                    <img className="img-responsive img-rounded workitem-img" src={imgUrl} alt="" />
                </div>
            )
        }

        getItemClasses = (el) => {
            const { viewMode } = this.props.mediaObjects;
            let classes = "workitem-card-text";
            if (el[`${viewMode}html`]) classes = 'workitem-card-title';
            if (viewMode == ConfigTypes.LIST) {
                classes = ' workitem-card-item-list';
            }
            return classes;
        }

        handleWishList = () => {
            let newItems = CartHelper.toggleListItem({
                cartObjects: this.props.cartObjects,
                configName: ConfigTypes.WORK, item: this.props.work
            });
            newItems = newItems.map(item => {
                if (item && item.metadata && item.metadata.fields) {
                    return { id: item.id, metadata: { fields: { ...item.metadata.fields } } }
                }
                return item;
            });
            this.props.updateCartObjects({ worksWishList: newItems });
            this.props.addToWatchlist({work: this.props.work, type: ConfigTypes.WORK, fm: this.fm});
        }

        showWishListIcon = () => {
            const { worksWishList } = this.props.cartObjects;
            let isInList = worksWishList.find(item => item.id == this.props.work.id);
            return (
                <div className="workitem-wishlistbox" onClick={this.handleWishList}>
                    <FontAwesomeIcon className="workitem-heart-bg" icon={faHeart} />
                    <div className={isInList ? "workitem-heart-active" : "workitem-heart-front"}>
                        <FontAwesomeIcon icon={faHeart} />
                    </div>
                </div>)
        }

        showOptionAsMapp = ({ el, i, fieldTxt }) => {
            if (fieldTxt.includes(" - ")) {
                let dFields = fieldTxt.split(" - ");
                return (
                    <div key={`workitemListItem${i}`} className={this.getItemClasses(el)}
                        onClick={this.onWorkItem}>
                        {dFields.map(df => <div>{df}</div>)}
                    </div>
                )
            }
            return (<div key={`workitemListItem${i}`} className={this.getItemClasses(el)}
                onClick={this.onWorkItem}>{fieldTxt}</div>)
        }

        showPortalWorkItem = () => {
            const { viewMode } = this.props.mediaObjects;
            const { isLoggedIn } = this.props.authObjects;
            let htmlClasses = "workitem-card-conten-grid";
            if (viewMode == ConfigTypes.GRID) {
                return this.showGridItem(viewMode);
            } else if (viewMode == ConfigTypes.LIST) {
                let showFields = this.getShowFields();
                const imgUrl = getImgUrl({ stateCurrentClip: this.props.work });
                htmlClasses = "workitem-card-content-list";
                return (
                    <li className="list-group-item workitem-list-item">
                        <div className="workitem-card-content-list">
                            {showFields.map((el, i) => {
                                let fieldTxt = parseStringField(this.props.work.metadata.fields[el.field], el[`${viewMode}filterType`]);
                                fieldTxt = checkMapping({ el, fieldTxt, term: ";" });
                                if (el.optionAsMapp) return this.showOptionAsMapp({ el, i, fieldTxt });
                                let isDate = el[`${viewMode}group`] && el[`${viewMode}group`].dategroup;
                                {
                                    if (i == 0) return this.showThumb(imgUrl);
                                    if (i == 6 && ConfigTypes.SHOW_CART && isLoggedIn) return this.showWishListIcon();
                                }
                                return (
                                    <div key={`workitemListItem${i}`} className={this.getItemClasses(el)} onClick={this.onWorkItem}>
                                        {!isDate && fieldTxt}
                                        {checkGroupFields({ isGroup: el[`${viewMode}group`], el, element: this.props.work, viewMode })}
                                    </div>)
                            })}
                        </div>
                    </li>)
            }
        }

        render() {
            return this.showPortalWorkItem();
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    authObjects: state.auth.authObjects,
    cartObjects: state.cart.cartObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    getWork: (data) => dispatch(actions.getWork(data)),
    addToWatchlist: (obj) => dispatch(actions.addToWatchlist(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(WorkItem))));